import { Box, LinearProgress } from '@mui/material';

export function LoadingScreen() {
    return (
        <Box className="flex w-full items-center justify-center py-16">
            <Box className="w-full max-w-sm">
                <LinearProgress color="primary" />
            </Box>
        </Box>
    );
}
